module.exports = __webpack_public_path__ + "img/seller.abe95986.svg";